import gql from 'graphql-tag';
import { feedFragment } from './commonFragments';

export const photoResultFragment = gql`
    ${feedFragment}
    fragment photoResult on PhotoResult {
        result
        llsid
        expTag
        serverExpTag
        pcursor
        feeds {
            ...feedContent
        }
        webPageArea
    }
`;
